import * as angular from "angular";
import {IController, IScope} from "angular";
import * as _ from "lodash";
import {DeliveriesDialogService} from "../../../deliveries/services/deliveries-dialog-service.service";
import {TaskModel} from "../../models/task.model";

export class TaskMiniCardCtrl implements IController {

  id: string;
  task: TaskModel;
  small: any;
  disableMainDetails: any;
  selectTask: any;

  constructor(private $task, private deliveriesDialogService: DeliveriesDialogService, private $scope: IScope) {
  }

  $onInit() {
    if (this.id) {
      this.$task(this.id).$bindCtrlToId(this.$scope, this, 'task', 'id');
    }
  }

  editTaskNotes(event, task) {
    this.deliveriesDialogService.editTaskNotes(event, task).then((task: TaskModel) => {
      if (!_.isUndefined(task)) {
        this.task = task;
      }
    })
  }

  onChangeStatus(task, status) {
    this.task = task;
  }

}


angular
  .module('bringoz.admin.tasks')
  .component('taskMiniCard', {
    bindings: {
      id: '<',
      task: '<',
      small: '<',
      disableMainDetails: '<?',
      selectTask: '<?'
    },
    template: require('./task-mini-card.html').default,
    controller: TaskMiniCardCtrl
  });
